import BaseMiddleware from "src/middleware/BaseMiddleware";
import { types as authType } from "src/store/modules/Auth.module";
import store from "src/store";

class GuestMiddleware extends BaseMiddleware {
	static goTo (next, nextPage = false) {
		if (nextPage) {
			if (typeof nextPage === "string") {
				return next({
					name: nextPage,
				});
			} else if (typeof nextPage === "function") {
				return nextPage(next);
			}
		}
		return nextPage;
	}

	async handle (next, to, from) {
		const matched = to.matched.find(m => m.meta.guest);
		const goTo = matched.meta.guest;
		if (!store.getters.isConnected) {
			try {
				await store.dispatch(authType.GET);
				if (!store.getters.isConnected) {
					return next();
				} else {
					return GuestMiddleware.goTo(next, goTo);
				}
			} catch (e) {
				return next();
			}
		} else {
			return GuestMiddleware.goTo(next, goTo);
		}
	}
}

export const rules = {};

export default GuestMiddleware;
